import React from 'react';
import PropTypes from 'prop-types';
import Fab from '@mui/material/Fab';

const UiFba = ({ children, ...restProps }) => {
  return <Fab {...restProps}>{children}</Fab>;
};

UiFba.propTypes = {
  children: PropTypes.node,
};

export default UiFba;
